export const syncStatusMap = {
  0: '不同步',
  1: '仅同步出签结果',
  2: '全部同步',
};
export const syncStatusOptions = [
  {
    label: '不同步',
    value: 0,
    desc: '此选项表示申请人所有状态均不会同步至飞猪，您需自行在卖家后台更新相应的状态',
  },
  {
    label: '仅同步出签结果',
    value: 1,
    desc: '此选项表示上上签仅同步最终出签结果（不含拒签），其余状态您需自行在卖家后台更新',
  },
  {
    label: '全部同步',
    value: 2,
    desc: '此选项表示除预审不通过和拒签外，申请人其余状态均会同步至飞猪',
  },
];



// WEBPACK FOOTER //
// ./src/maps/fliggy-maps.js